module.exports = {
    eg: {
        'zh-CN': '英卓游戏',
        'zh-TW': '英卓遊戲',
        'en-US': 'Enjoy Game',
        'th-TH': 'Enjoy Game',
        'vi-VN': 'Enjoy Game'
    },
    eg_mengguo: {
        'zh-CN': '萌果游戏',
        'zh-TW': '萌果遊戲',
        'en-US': 'Enjoy Game',
        'th-TH': 'Enjoy Game',
        'vi-VN': 'Enjoy Game'
    },
    home: {
        'zh-CN': '首页',
        'zh-TW': '首頁',
        'en-US': 'Home',
        'th-TH': 'หน้าหลัก',
        'vi-VN': 'Trang chủ'
    },
    about: {
        'zh-CN': '关于我们',
        'zh-TW': '關於我們',
        'en-US': 'About Us',
        'th-TH': 'เกี่ยวกับเรา',
        'vi-VN': 'Giới thiệu'
    },
    center: {
        'zh-CN': '游戏中心',
        'zh-TW': '遊戲中心',
        'en-US': 'Game Center',
        'th-TH': 'ศูนย์เกม',
        'vi-VN': 'Trung tâm game'
    },
    store: {
        'zh-CN': '在线商城',
        'zh-TW': '在線商城',
        'en-US': 'Online Shop',
        'th-TH': 'ร้านค้าออนไลน์',
        'vi-VN': 'Shop online'
    },
    business: {
        'zh-CN': '商务合作',
        'zh-TW': '商務合作',
        'en-US': 'Business',
        'th-TH': 'ธุรกิจ',
        'vi-VN': 'Thương mại'
    },
    news: {
        'zh-CN': '新闻资讯',
        'zh-TW': '新聞資訊',
        'en-US': 'News',
        'th-TH': 'ข่าว',
        'vi-VN': 'Thông tin'
    },
    recommendGame: {
        'zh-CN': '推荐游戏',
        'zh-TW': '推薦遊戲',
        'en-US': 'Recommended Games',
        'th-TH': 'Recommended Games',
        'vi-VN': 'Recommended Games'
    },
    cooperation: {
        'zh-CN': '商务合作：',
        'zh-TW': '商務合作：',
        'en-US': 'Cooperation: ',
        'th-TH': 'Cooperation',
        'vi-VN': 'Cooperation'
    },
    hr: {
        'zh-CN': '求职需求：',
        'zh-TW': '求職需求：',
        'en-US': 'HR: ',
        'th-TH': 'HR: ',
        'vi-VN': 'HR: ',
    },
    cs: {
        'zh-CN': '客服需求：',
        'zh-TW': '客服需求：',
        'en-US': 'CS: ',
        'th-TH': 'CS: ',
        'vi-VN': 'CS: '
    },
    aboutCompany: {
        'zh-CN': '作为专业的移动手机游戏发行公司，EnjoyGame致力于将中国精品手机游戏输出和发行到海外市场。目前发行范围覆盖港澳台、东南亚、亚太、欧美等上百个国家和地区。其发行的《天域战记》、《幻想之刃》、《暗黑联盟》等多款产品在海外地区广受欢迎，多次获得谷歌和苹果的推荐，在各榜单上均有优异表现。目前Enjoygame在持续招贤纳士，并积极寻求与更多优秀的国内外产品和机构的合作。',
        'zh-TW': '作為專業的移動手機遊戲發行公司，EnjoyGame致力於將中國精品手機遊戲輸出和發行到海外市場。目前發行範圍覆蓋港澳台、東南亞、亞太、歐美等上百個國家和地區。其發行的《天域戰記》、《幻想之刃》、《暗黑聯盟》等多款產品在海外地區廣受歡迎，多次獲得谷歌和蘋果的推薦，在各榜單上均有友誼表現。目前EnjoyGame在持續招賢納士，并積極尋求與更多優秀的國內外產品和機構的合作。',
        'en-US': 'EnjoyGame is a preeminent mobile game publisher, which aims at delivering the most outstanding mobile games in overseas markets. EnjoyGame publishes in many countries and regions, including Taiwan, South East Asia, Oceanic, North and South America and Europe. Paradise War, Sword of Fantasy, Dark League and more games have already been brought to international markets and received great reputation. Not only got great place on both AppStore and GooglePlay rankings, they also got multiple recommendations by AppStore and GooglePlay. EnjoyGame is recruiting now talented and passionate employees right now. We also hungered for more corporation with excellent developers and other partners globally. ',
        'th-TH': 'EnjoyGame is a preeminent mobile game publisher, which aims at delivering the most outstanding mobile games in overseas markets. EnjoyGame publishes in many countries and regions, including Taiwan, South East Asia, Oceanic, North and South America and Europe. Paradise War, Sword of Fantasy, Dark League and more games have already been brought to international markets and received great reputation. Not only got great place on both AppStore and GooglePlay rankings, they also got multiple recommendations by AppStore and GooglePlay. EnjoyGame is recruiting now talented and passionate employees right now. We also hungered for more corporation with excellent developers and other partners globally. ',
        'vi-VN': 'EnjoyGame is a preeminent mobile game publisher, which aims at delivering the most outstanding mobile games in overseas markets. EnjoyGame publishes in many countries and regions, including Taiwan, South East Asia, Oceanic, North and South America and Europe. Paradise War, Sword of Fantasy, Dark League and more games have already been brought to international markets and received great reputation. Not only got great place on both AppStore and GooglePlay rankings, they also got multiple recommendations by AppStore and GooglePlay. EnjoyGame is recruiting now talented and passionate employees right now. We also hungered for more corporation with excellent developers and other partners globally. '
    },
    login: {
        'zh-CN': '登录',
        'zh-TW': '登錄',
        'en-US': 'Login',
        'th-TH': 'Login',
        'vi-VN': 'Login'
    },
    account: {
        'zh-CN': '账号',
        'zh-TW': '賬號',
        'en-US': 'Account',
        'th-TH': 'Account',
        'vi-VN': 'Account'
    },
    accountNotEmpty: {
        'zh-CN': '账号不能为空',
        'zh-TW': '賬號不能為空',
        'en-US': 'Account is needed',
        'th-TH': 'Account is needed',
        'vi-VN': 'Account is needed'
    },
    password: {
        'zh-CN': '密码',
        'zh-TW': '密碼',
        'en-US': 'Password',
        'th-TH': 'Password',
        'vi-VN': 'Password'
    },
    passwordNotEmpty: {
        'zh-CN': '密码不能为空',
        'zh-TW': '密碼不能為空',
        'en-US': 'Password is needed',
        'th-TH': 'Password is needed',
        'vi-VN': 'Password is needed'
    },
    captcha: {
        'zh-CN': '验证码',
        'zh-TW': '驗證碼',
        'en-US': 'Captcha',
        'th-TH': 'Captcha',
        'vi-VN': 'Captcha'
    },
    captchaNotEmpty: {
        'zh-CN': '验证码不能为空',
        'zh-TW': '驗證碼不能為空',
        'en-US': 'Captcha is needed',
        'th-TH': 'Captcha is needed',
        'vi-VN': 'Captcha is needed'
    },
    captchaError: {
        'zh-CN': '验证码错误',
        'zh-TW': '驗證碼錯誤',
        'en-US': 'Captcha error',
        'th-TH': 'Captcha error',
        'vi-VN': 'Captcha error'
    },
    passwordError: {
        'zh-CN': '密码错误',
        'zh-TW': '密碼錯誤',
        'en-US': 'Password error',
        'th-TH': 'Password error',
        'vi-VN': 'Password error'
    },
    userNotExits: {
        'zh-CN': '用户名不存在',
        'zh-TW': '用戶名不存在',
        'en-US': 'User not exists',
        'th-TH': 'User not exists',
        'vi-VN': 'User not exists'
    },
    loginFail: {
        'zh-CN': '登录失败',
        'zh-TW': '登錄失敗',
        'en-US': 'Login Failed',
        'th-TH': 'Login Failed',
        'vi-VN': 'Login Failed'
    },
    loginFailErrorCode: {
        'zh-CN': '登录失败，错误码为：',
        'zh-TW': '登錄失敗，錯誤碼為：',
        'en-US': 'Login failed, error code: ',
        'th-TH': 'Login failed, error code: ',
        'vi-VN': 'Login failed, error code: '
    },
    registerFail: {
        'zh-CN': '注册失败',
        'zh-TW': '註冊失敗',
        'en-US': 'Registration Failed',
        'th-TH': 'Registration Failed',
        'vi-VN': 'Registration Failed'
    },
    registerFailErrorCode: {
        'zh-CN': '注册失败，错误码为：',
        'zh-TW': '註冊失敗，錯誤碼為：',
        'en-US': 'Registration failed，error code:',
        'th-TH': 'Registration failed，error code:',
        'vi-VN': 'Registration failed，error code:'
    }
};



// WEBPACK FOOTER //
// ./src/lang/nav.js